module.exports = __webpack_public_path__ + "images/8a4da4c3824c1d8d07a9c22affb1a5a1.png";